/* global PACKAGE_VERSION */
import { initTelemetry } from './utilities/telemetry';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { registerBrandDevTools } from './languages';

registerBrandDevTools();

initTelemetry({ appVersion: typeof PACKAGE_VERSION === 'undefined' ? 'dev' : PACKAGE_VERSION });

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>
);
